import React from 'react';
import type { ComponentType } from 'react';
import { Typography } from '@mui/material';
import type { SportType, SportSettings } from '@/types';
import type { SportSettingsFormProps } from './types';
import { FootballSettingsForm }   from './FootballSettingsForm';
import { HockeySettingsForm }     from './HockeySettingsForm';
import { BasketballSettingsForm } from './BasketballSettingsForm';
import { TennisSettingsForm }     from './TennisSettingsForm';
import { VolleyballSettingsForm } from './VolleyballSettingsForm';
import { HandballSettingsForm }   from './HandballSettingsForm';
import { PadelSettingsForm }      from './PadelSettingsForm';
import { SwimmingSettingsForm }   from './SwimmingSettingsForm';
import { DefaultSportSettingsForm } from './DefaultSportSettingsForm';

export type { SportSettingsFormProps };

const SPORT_SETTINGS_FORMS: Partial<Record<SportType, ComponentType<SportSettingsFormProps>>> = {
  football:   FootballSettingsForm,
  hockey:     HockeySettingsForm,
  basketball: BasketballSettingsForm,
  tennis:     TennisSettingsForm,
  volleyball: VolleyballSettingsForm,
  handball:   HandballSettingsForm,
  padel:      PadelSettingsForm,
  swimming:   SwimmingSettingsForm,
  poker:      DefaultSportSettingsForm,
  other:      DefaultSportSettingsForm,
};

interface SportSettingsFormWrapperProps {
  sportType: SportType;
  value: SportSettings;
  onChange: (v: SportSettings) => void;
  disabled?: boolean;
}

export const SportSettingsForm: React.FC<SportSettingsFormWrapperProps> = ({
  sportType,
  value,
  onChange,
  disabled,
}) => {
  const Form = SPORT_SETTINGS_FORMS[sportType] ?? DefaultSportSettingsForm;

  if (!sportType) {
    return (
      <Typography color="text.secondary" variant="body2">
        Выберите вид спорта на предыдущем шаге, чтобы настроить параметры.
      </Typography>
    );
  }

  return <Form value={value} onChange={onChange} disabled={disabled} />;
};

export {
  FootballSettingsForm,
  HockeySettingsForm,
  BasketballSettingsForm,
  TennisSettingsForm,
  VolleyballSettingsForm,
  HandballSettingsForm,
  PadelSettingsForm,
  SwimmingSettingsForm,
  DefaultSportSettingsForm,
};
